module.exports = __webpack_public_path__ + "static/GHGSat-3f528154396de91e69d16feaeaee589a.jpg";